import * as React from "react";
const IconBo = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 513 342"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path  d="M0 0h513v114H0z" />
    <path  d="M0 114h513v114H0z" />
    <path  d="M0 228h513v114H0z" />
  </svg>
);
export default IconBo;
